(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-content-read-more"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('read-more-toggle')) {
    customElements.define(
      'read-more-toggle',
      class ReadMoreToggle extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('.read-more-section__toggle');
          const content = this.querySelector('.read-more-content');
          const toggleWrapper = this.querySelector('.read-more-section__toggle-wrapper');
          const label = button ? button.querySelector('span') : null;
          if (!button || !content || !toggleWrapper || !label) return;

          const updateVisibility = () => {
            const collapsedMaxHeightPx = 25 * parseFloat(getComputedStyle(document.documentElement).fontSize);

            if (content.scrollHeight <= collapsedMaxHeightPx + 1) {
              content.classList.remove('is-clamped');
              toggleWrapper.hidden = true;
            } else {
              content.classList.add('is-clamped');
              toggleWrapper.hidden = false;
            }
          };

          updateVisibility();
          window.addEventListener('load', updateVisibility);

          button.addEventListener('click', () => {
            const isCollapsed = label.textContent.trim() === 'Read More';

            if (isCollapsed) {
              label.textContent = 'Read Less';
              content.style.maxHeight = '100%';
              toggleWrapper.style.backgroundImage = 'none';
              toggleWrapper.style.margin = '0';
              toggleWrapper.style.padding = '0';
              toggleWrapper.style.position = 'static';
            } else {
              label.textContent = 'Read More';
              content.style.maxHeight = '25rem';
              toggleWrapper.style.backgroundImage = 'linear-gradient(to bottom, transparent, rgb(var(--color-background)))';
              toggleWrapper.style.position = 'absolute';
              toggleWrapper.style.margin = '4rem 0 0';
              toggleWrapper.style.padding = '3rem 0 0.8rem';
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-bottom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var HEADER_OFFSET = 100; // px of space left above the jump target

    function scrollToElement(el) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    function setupReadMore(wrapper) {
      var content = wrapper.querySelector('.read-more-content');
      var toggleWrapper = wrapper.querySelector('.footer-bottom__toggle-wrapper');
      var button = wrapper.querySelector('.footer-bottom__toggle');
      if (!content || !toggleWrapper || !button || wrapper.dataset.readMoreReady) return;
      wrapper.dataset.readMoreReady = 'true';

      var label = button.querySelector('span');
      var collapsedMaxHeightPx = 25 * parseFloat(getComputedStyle(document.documentElement).fontSize);

      if (content.scrollHeight <= collapsedMaxHeightPx + 1) {
        toggleWrapper.hidden = true;
        return;
      }

      function expand() {
        content.classList.remove('is-clamped');
        wrapper.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        if (label) label.textContent = 'Read Less';
      }

      function collapse() {
        content.classList.add('is-clamped');
        wrapper.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        if (label) label.textContent = 'Read More';
      }

      wrapper.footerBottomExpand = expand;
      collapse();

      button.addEventListener('click', function () {
        if (wrapper.classList.contains('is-expanded')) {
          collapse();
          scrollToElement(wrapper);
        } else {
          expand();
        }
      });
    }

    // Opens the Read More box if the target sits inside it, then scrolls with the 100px offset
    function jumpTo(id, updateUrl) {
      if (!id) return false;
      var target = document.getElementById(id);
      if (!target) return false;

      var wrapper = target.closest('.footer-bottom-parent');
      if (wrapper && typeof wrapper.footerBottomExpand === 'function') {
        wrapper.footerBottomExpand();
      }

      // wait for the expanded layout before measuring the position
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scrollToElement(target);
        });
      });

      if (updateUrl && history.pushState) {
        history.pushState(null, '', '#' + encodeURIComponent(id));
      }
      return true;
    }

    function init() {
      document.querySelectorAll('.footer-bottom-parent').forEach(setupReadMore);

      // page opened with a #hash in the URL
      if (window.location.hash) {
        var id = decodeURIComponent(window.location.hash.slice(1));
        setTimeout(function () { jumpTo(id, false); }, 150);
      }
    }

    // any same-page link such as <a href="#choose">, anywhere on the page
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href*="#"]');
      if (!link) return;

      var url = new URL(link.href, window.location.href);
      if (!url.hash || url.pathname !== window.location.pathname) return;

      if (jumpTo(decodeURIComponent(url.hash.slice(1)), true)) {
        event.preventDefault();
      }
    });

    window.addEventListener('hashchange', function () {
      jumpTo(decodeURIComponent(window.location.hash.slice(1)), false);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
			this.headerTransparent = this.header.querySelector('.header-transparent');
				
			if(this.headerTransparent){
				const setTopPosition = () => { 
					this.headerTopPosition = this.header.offsetHeight;
					this.header.style.marginBottom = `-${this.header.offsetHeight}px`;
				}

				// setTopPosition();
				requestAnimationFrame(setTopPosition);

				let resizeTimeout;
				window.addEventListener('resize', () => {
					clearTimeout(resizeTimeout);
					resizeTimeout = setTimeout(setTopPosition, 60);
				});

				document.body.classList.add('header-transparent-active');
      } 

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop === 0 ) {
				this.classList.add('header-at-top');
			} else {
				this.classList.remove('header-at-top');
			}		

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const transparentHeader = document.querySelector('.header-transparent');
    if (transparentHeader) {
      const headerHeight = transparentHeader.offsetHeight;
      transparentHeader.style.marginBottom = `-${headerHeight}px`;
    }
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
